import { Navigate, Route, Routes } from "react-router-dom";

import { useSession } from "@/auth/session/SessionProvider";

import { ConfirmSignUpPage } from "./ConfirmSignUpPage";
import { ForgotPasswordPage } from "./ForgotPasswordPage";
import { ResetPasswordPage } from "./ResetPasswordPage";
import { SignInPage } from "./SignInPage";
import { SignUpPage } from "./SignUpPage";

/**
 * The sign-in surface: our own pages at our own origin, replacing the hop to
 * Cognito's hosted login. Mounted only in {@code cognito} mode — under the
 * redirect flow these paths don't exist and sign-in is the IdP's job.
 */
export function AuthRoutes() {
  const session = useSession();

  // Already signed in — nothing here applies. Bounce home rather than showing a
  // sign-in form to someone who has a session (reachable via a bookmark, or the
  // back button after signing in).
  if (session.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/signup/confirm" element={<ConfirmSignUpPage />} />
      <Route path="/forgot" element={<ForgotPasswordPage />} />
      <Route path="/forgot/reset" element={<ResetPasswordPage />} />
      {/* Any other /signin-ish path is a typo or a stale link. */}
      <Route path="*" element={<Navigate to="/signin" replace />} />
    </Routes>
  );
}
